// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * API module for retrieving the organization's latest locked period and each currency's locked initial true-up.
 */
import * as z from 'zod';
import { initialTrueUpsForAllCurrenciesSchema } from '@/accounting/api/types';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';

const getInitialTrueUpsResponseSchema = z
  .object({
    data: initialTrueUpsForAllCurrenciesSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    initialTrueUps: data,
  }));

type GetInitialTrueUpsResponse = z.infer<
  typeof getInitialTrueUpsResponseSchema
>;

/** Retrieves the organization's latest locked period and each currency's locked initial true-up. */
export async function getInitialTrueUps(): Promise<GetInitialTrueUpsResponse> {
  const url = '/v1/accounting/initial-true-ups';
  const response = await api.get(url);

  return parseResponse(getInitialTrueUpsResponseSchema, response.data, {
    schemaName: 'InitialTrueUps',
    endpoint: url,
  });
}
